module.exports = __webpack_public_path__ + "img/logo_republika.fb4c77f6.png";